/**
 * @author gll
 * 功能：组织业务关系管理功能
 */

import { Service } from '@/tools'
export class BusRelService<T extends TUser.BusRel> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.BusRel}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：新增业务关系
   */
  addBusRel = (data: T['ApiAddBusRel']['req']): Promise<T['ApiAddBusRel']['res']> => this.post2('v1/ApiAddBusRel', data)

  /**
   * 功能：分批查询业务组列表
   */
  pageList = <K extends T['ApiPageList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageList', data)

  /**
   * 功能：校验业务关系创建合法性
   */
  checkBusRelLegitimacy = <K extends T['ApiCheckBusRelLegitimacy']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiCheckBusRelLegitimacy', data)

  /**
   * 功能：删除业务关系
   */
  deleteBusRel = <K extends T['ApiDeleteBusRel']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteBusRel', data)

  /**
   * 功能：启用-禁用业务关系
   */
  updateBusRelState = <K extends T['ApiUpdateBusRelState']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateBusRelState', data)
}
